// extracted by mini-css-extract-plugin
module.exports = {"new-table":"FinalReportActionableTable_new-table__1zYww"};